const languages = ["C++", "Php", "JavaScript", "Dart"];

const techAndFrameWorks = [
  "Laravel",
  "Cakephp",
  "Node",
  "React",
  "Flutter",
  "jQuery",
  "HTML",
  "CSS",
];

const databaseAndTools = ["MySql", "SQLite", "MongoDB", "PostgreSQL"];

const other = ["Teamwork", "Problem Solving", "Good Communication Skills"];

export { languages, techAndFrameWorks, databaseAndTools, other };
